import { useEffect, useState } from 'react'

export type SnackbarPosition = {
  horizontal: 'left' | 'center' | 'right'
  vertical: 'bottom' | 'top'
}

interface Options {
  title: string
  texts: Texts
  buttons: IButton[]
  allowed: boolean
}

interface Texts {
  text1?: string
  text2?: string
}
interface IButton {
  variant: 'text' | 'outlined' | 'contained'
  label: string
  event: () => void
  size: 'small' | 'large' | 'medium'
}

export type OpenDialog = (
  title: string,
  texts: Texts,
  buttons: IButton[],
  allowed: boolean,
) => void

export const useDialog = () => {
  const [open, setOpen] = useState<boolean>(false)
  const [options, setOptions] = useState<Options>()

  useEffect(() => {
    if (options?.title) setOpen(true)
  }, [options])

  const onOpenDialog: OpenDialog = (title, texts, buttons, allowed) => {
    setOptions({ title, texts, buttons, allowed })
  }
  const onCloseDialog = () => setOpen(false)

  return {
    ...options,
    open,
    closeIcon: onCloseDialog,
    onOpenDialog,
  }
}
